import { Checkbox, FormControlLabel, makeStyles } from '@material-ui/core';
import React from 'react';
import { styledBy } from '../../../utils/styles';

const useStyles = makeStyles((theme) => ({
    input: {
        color: theme.palette.ascents.textDark,
        "&:before": {
            borderBottom: `2px solid ${theme.palette.ascents.baseLow} !important`,
        },
        "&:after": {
            borderBottomColor: styledBy("ascent", theme.palette.ascents),
            borderBottom: "none",
            background: `linear-gradient(45deg, ${theme.palette.ascents.primary} 20%, ${theme.palette.ascents.orange}) 80%`,
            height: "2px",
        },
        "&.MuiInputLabel-asterisk": {
            color: theme.palette.ascents.orange,
        },
        "&:hover": {
            "&:before": {
                borderBottom: `2px solid ${theme.palette.ascents.textDark} !important`,
            },
        }
    },
    label: {
        color: styledBy("ascent", theme.palette.ascents),
        "&.MuiInputLabel-shrink": {
            color: theme.palette.ascents.textDark,
        },
        "&.MuiInputLabel-asterisk": {
            color: theme.palette.ascents.orange,
        },
    },
    labelForDate: {
        fontSize: 10,
    },
}));

const CheckboxInput = ({
    isChecked = true,
    ascent = 'primary',
    name,
    label = '',
    readOnly = false,
    hideLabel = false,
    ...props
}) => {
    const classes = useStyles({ ascent });
    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={isChecked}
                    name={name}
                    color="primary"
                    value={isChecked ? 1 : 0}
                    readOnly={readOnly}
                    className={classes.input}
                />
            }
            label={label}
            {...props}
        />
    )
}

export default CheckboxInput
